<template>
    <section class="layout-list">
        <div class="layout contacts-list-page">
            <div class="side-panel">
                <contact-layout-list :contact-layouts-list="contactLayouts" :user-id="userId" :default-layout-id="layoutId" />
            </div>

            <div v-if="layoutDetailsName === 'default'" class="default-layout">
                <default-layout />
            </div>

            <section v-else class="content-area">
                <div class="layout-list-name">
                    <div class="header-line grid-container">
                        <div id="closeIcon">
                            <ds-icon-button
                                slot="leading"
                                color="#242433"
                                name="x"
                                @click="renderDefault"
                            />
                        </div>

                        <div class="contact-layout-header">
                            <h3 class="profile-label grid-item">
                                {{ layoutName }}
                            </h3>
                        </div>
                    </div>

                    <div class="horiz" />

                    <div
                        v-if="layoutDetailsName === 'everything'"
                        class="layout-details"
                    >
                        <everything-layout :user-id="userId" :contact-customizable-layout-obj="everyThingLayout" />
                    </div>

                    <div v-else class="layout-details">
                        <ds-text-button
                            class="layoutSettingsTab"
                            data-qa="layout-settings-tab"
                            :class="{'placeholder-line': selectedSettingLayoutTab('Layout settings')}"
                            @click="selectSetTab('Layout settings'), showSettingsPage = true"
                        >
                            Layout settings
                        </ds-text-button>

                        <ds-text-button
                            class="layoutSettingsTab"
                            data-qa="users-assigned-tab"
                            :class="{'placeholder-line': selectedSettingLayoutTab('Users assigned')}"
                            @click="selectSetTab('Users assigned'), showSettingsPage = false"
                        >
                            Users assigned({{ layoutUsersAccessCount }})
                        </ds-text-button>

                        <section v-if="showSettingsPage" class="layout-tab-content">
                            <div class="description">
                                Select a tab below to view and customize tab content. Drag and drop the tabs to rearrange
                                them, click the
                                edit icon on the tab name to change the tab name and visibility options.
                            </div>

                            <div class="record">
                                <div class="slides">
                                    <draggable
                                        ref="cards"
                                        v-model="contactCustomizableLayout.layoutComponents"
                                        class="lists"
                                        v-bind="getCardDraggableOptions()"
                                        @end="updateTabOrder"
                                    >
                                        <div
                                            v-for="(ls, index) in contactCustomizableLayout.layoutComponents"
                                            :key="index"
                                            ref="tab"
                                            :class="{'tab-selected': setTabSelected(ls.name)}"
                                            class="capsule-buttons"
                                            @click="sendTabEvent(ls.name, index)"
                                        >
                                            <div class="drag-icon">
                                                <ds-icon
                                                    class="drag-target-draggable"
                                                    name="draggable"
                                                />
                                                {{ ls.name }}
                                            </div>

                                            <span @click="editTab(contactCustomizableLayout, index)">
                                                <ds-icon class="drag-icon drag-target" name="edit" />
                                            </span>
                                        </div>
                                    </draggable>
                                </div>
                            </div>
                            <div class="input-row">
                                <ds-dropdown class="dropdown basic-dropdown-list" pin-bottom>
                                    <div>
                                        <ds-text-button button-class="text-button">
                                            <ds-icon class="add-icon" name="add-fill" />

                                            <span class="add-a-tab-label">
                                                Add a tab
                                            </span>
                                        </ds-text-button>
                                    </div>

                                    <div slot="menu">
                                        <div class="dropdown-menu-item" @click="addATabModal">
                                            <ds-icon class="add-icon" name="add" />

                                            <div class="add-tab-label">
                                                create a custom tab
                                            </div>
                                        </div>

                                        <div class="add-section-tab-label">
                                            System tabs
                                        </div>

                                        <ul class="add-tab-dropdown-menu-list">
                                            <li
                                                v-for="(field, index) in systemTabList"
                                                :key="index"
                                                class="dropdown-menu-item"
                                                @click="showSystemTabField(field)"
                                            >
                                                {{ field }}
                                            </li>
                                        </ul>
                                    </div>
                                </ds-dropdown>
                            </div>

                            <div class="tab-names">
                                {{ selectedTab }}
                            </div>

                            <div
                                v-if="selectedTab !== 'Contact Info' && (cloneOriginalSystemTabList.includes(selectedTab) || copyEverythingTabList.includes(selectedTab))"
                                class="card-image"
                            >
                                <p class="card-header">
                                    The Content Of This {{ selectedTab }} Tab Cannot be Customized
                                </p>
                            </div>

                            <contact-layout-details
                                :user-id="userId"
                                :selected-tab-name="selectedTab"
                                :contact-customizable-layout-obj="contactCustomizableLayout"
                                :show-campaign-stealth-tab="showCampaignStealthTab"
                            />

                            <ds-modal
                                :is-open="isTabModalOpen"
                                :title.sync="tabTitle"
                                show-close
                                @close="modalClose"
                            >
                                <template #header>
                                    <ds-button
                                        v-if="showTabAction"
                                        :disabled="actionDisabled"
                                        @click="addATab"
                                    >
                                        Save
                                    </ds-button>
                                </template>

                                <template #default>
                                    <div>
                                        <ds-input-field
                                            v-model="tabName"
                                            name="tabName"
                                            label="Tab name"
                                            :submitted="submitted"
                                            required
                                            :invalid="submitted"
                                            @keyup="isTabNameDuplicate"
                                        >
                                            <template #error>
                                                <small v-if="submitted">
                                                    {{ tabErrorMessage }}
                                                </small>
                                            </template>
                                        </ds-input-field>
                                    </div>

                                    <div v-if="enableTabUpdateButtons" class="button-space">
                                        <div>
                                            <ds-button
                                                id="save-tab"
                                                :disabled="disableSave"
                                                @click="updateTabButton"
                                            >
                                                Save
                                            </ds-button>
                                        </div>

                                        <div class="minus">
                                            <ds-icon-button
                                                :disabled="false"
                                                class="minus"
                                                name="minus-circle"
                                                @click="openToggleTabDeleteConfirmModal"
                                            />

                                            <span>Remove tab from layout</span>
                                        </div>
                                    </div>
                                </template>
                            </ds-modal>

                            <ds-confirm-dialog
                                :is-open="isToggleLayoutConfirmModalOpen"
                                :message="deleteTabNameMessage"
                                cancel-button-class="cancel"
                                cancel-label="Cancel"
                                confirm-button-class="negative"
                                confirm-label="Delete tab"
                                title="Delete tab?"
                                @cancel="confirmModalCancel"
                                @confirm="confirmModalTabDelete"
                            />
                        </section>

                        <section v-else class="layout-tab-content">
                            <contact-layout-users-assigned :layout-data="layoutData" :user-id="userId" />
                        </section>
                    </div>
                </div>
            </section>
        </div>
    </section>
</template>
<script>

import ContactLayoutDetails from './ContactLayoutDetails';
import ContactLayoutUsersAssigned from './ContactLayoutUsersAssigned';
import ContactLayoutList from './ContactLayoutList';
import DefaultLayout from './DefaultLayout';
import axios from 'axios';
import Draggable from 'vuedraggable';
import cloneDeep from 'lodash.clonedeep';
import EverythingLayout from './EverythingLayout';

export default {
    components: {
        ContactLayoutDetails,
        ContactLayoutList,
        DefaultLayout,
        EverythingLayout,
        ContactLayoutUsersAssigned,
        Draggable,
    },

    props: {
        userId: [String, Number],
        layoutId: [String, Number],
        showCampaignStealthTab: Boolean,
    },

    data() {
        return {
            layoutUsersAccessCount: 0,
            layoutSettings: 'Layout settings',
            showSettingsPage: true,
            layoutDetailsName: 'default',
            layoutName: '',
            tabErrorMessage: 'System tabs cannot be renamed',
            deleteTabNameMessage: '',
            tabTitle: 'Create a new tab',
            tabName: '',
            disableSave: false,
            selectedTab: 'Contact Info',
            layoutTab: {},
            showTabAction: true,
            enableTabUpdateButtons: false,
            tempTabIndex: 0,
            systemTabList: [],
            enableSaveTabButton: false,
            tabIndex: 0,
            originalSystemTabList: ['Contact Info', 'Notes', 'Tags', 'Money', 'Tasks', 'Appointments', 'Form submissions', 'Emails', 'Campaigns', 'Opportunities', 'Scored activity', 'Files', 'Linked contacts', 'Follow-up sequences', 'Web profile', 'Access priviliges', 'Referral partner'],
            copyEverythingTabList: ['Notes', 'Tags', 'Money', 'Tasks', 'Form submissions', 'Scored activity', 'Files', 'Linked contacts', 'Follow-up sequences', 'Web profile', 'Access privileges', 'Refferal partner'],
            cloneOriginalSystemTabList: [],
            emitGetAll: false,
            contactLayouts: [],
            saveEvent: '',
            contactCustomizableLayout: {},
            layoutData: {},
            defaultLayoutId: 0,
            everyThingLayout: {},
            sendDefaultLayout: {},
            emitDefaultLayoutId: false,
            updatedDefaultLayoutId: 0,
            isToggleLayoutConfirmModalOpen: false,
            isTabModalOpen: false,
            submitted: false,
        };
    },

    beforeDestroy() {
        this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', false);
        this.$root.$off('LAYOUT_DISPLAY', this.getLayoutDetails);
        this.$root.$off('LAYOUT_LIST_DISPLAY', this.getLayoutListDetails);
        this.$root.$off('LAYOUT_SAVE_DETAILS', this.getLayoutSaveDetails);
        this.$root.$off('LAYOUT_GET_ALL', this.getAllLayouts);
    },

    mounted() {
        this.$root.$on('ADDED_USERS_COUNT', this.addedUsersCount);

        this.$root.$on('LAYOUT_DISPLAY', this.getLayoutDetails);

        this.$root.$on('LAYOUT_LIST_DISPLAY', this.getLayoutListDetails);

        this.$root.$on('LAYOUT_SAVE_DETAILS', this.getLayoutSaveDetails);

        this.$root.$on('LAYOUT_GET_ALL', this.getAllLayouts);

        this.$root.$on('DELETE_LAYOUT', this.getAllLayoutsAndSendDefaultLayout);
    },

    created() {
        this.displayCampaignStealth();
        this.defaultLayoutId = Number(this.layoutId);
        this.updatedDefaultLayoutId = Number(this.layoutId);
        this.emitGetAll = true;
        this.getContactLayoutList();
        this.cloneOriginalSystemTabList = cloneDeep(this.originalSystemTabList);
        this.cloneOriginalSystemTabList.splice(0, 1);
        const name = (this.contactCustomizableLayout.layoutComponents) && this.contactCustomizableLayout.layoutComponents[this.tabIndex] ? this.contactCustomizableLayout.layoutComponents[this.tabIndex].name : '';

        this.setTabSelected(name);
        this.getTabsDropDown();
    },

    methods: {

        isTabNameDuplicate() {
            const filteredValues = this.contactCustomizableLayout.layoutComponents.filter((contactLayoutComponents) => {
                return contactLayoutComponents.name === this.tabName;
            });

            if (this.tabName.length === 0) {
                this.submitted = true;
                this.tabErrorMessage = '';
            } else if (filteredValues.length > 0 && this.contactCustomizableLayout.layoutComponents[this.tempTabIndex].name !== this.tabName) {
                this.submitted = true;
                this.tabErrorMessage = 'This tab name already exists. Please select a unique tab name.';
            } else {
                this.submitted = false;
                this.tabErrorMessage = '';
            }
        },

        displayCampaignStealth() {
            if (this.showCampaignStealthTab) {
                this.originalSystemTabList.push('Campaigns stealth');
                this.copyEverythingTabList.push('Campaigns stealth');
            }
        },

        addedUsersCount({ count, name }) {
            this.layoutUsersAccessCount = count;
            this.emitGetAll = true;
            this.layoutName = name;
            this.getContactLayoutList();
        },

        selectedSettingLayoutTab(data) {
            return this.layoutSettings === data;
        },

        selectSetTab(data) {
            this.layoutSettings = data;
        },

        getCardDraggableOptions() {
            return {
                animation: 0,
                fallbackClass: 'card-dragging',
                fallbackTolerance: 0,
                forceFallback: true,
                ghostClass: 'status-placeholder',
                group: 'deals',
                handle: '.capsule-buttons',
            };
        },

        getAllLayoutsAndSendDefaultLayout(data) {
            this.layoutDetailsName = 'everything';
            this.emitGetAll = true;
            this.updatedDefaultLayoutId = Number(data.layoutId);
            this.layoutName = this.everyThingLayout.name;
            this.emitDefaultLayoutId = true;
            this.sendDefaultLayout = data;
            this.getContactLayoutList();
        },

        getAllLayouts(data) {
            const layoutDetails = data.split('#*_#');
            const layoutDetailsName = layoutDetails[0];
            const eventType = layoutDetails[1];
            const tabIndexId = layoutDetails[2];

            this.tabIndex = Number(tabIndexId);
            this.headerIndex = 0;
            this.layoutDetailsName = 'layout';
            this.layoutName = layoutDetailsName;
            this.saveEvent = eventType;

            this.emitGetAll = true;
            this.getContactLayoutList();
        },

        getLayoutSaveDetails(data) {
            this.contactCustomizableLayout = data.contactCustomizableLayout;
            this.saveEvent = data.saveEvent;
            this.emitGetAll = true;

            this.saveContactLayoutDetails();
        },

        getLayoutDetails(data) {
            this.layoutSettings = 'Layout settings';
            this.showSettingsPage = true;
            this.contactCustomizableLayout = data;

            if (data.name === 'Everything layout') {
                this.layoutDetailsName = 'everything';
                this.layoutName = data.name;
                this.everyThingLayout = data;
                this.$root.$emit('EVERTHING_LAYOUT_DISPLAY_DETAILS', this.contactCustomizableLayout);
            } else {
                this.layoutDetailsName = 'layout';
                this.layoutName = data.name;
                this.tabIndex = 0;
                this.getTabsDropDown();
                this.tabSelectedDetails(this.tabIndex, this.contactCustomizableLayout);
                this.layoutData.contactCustomizableLayout = this.contactCustomizableLayout;
                this.layoutData.tabIndex = this.tabIndex;
                this.layoutUsersAccessCount = this.contactCustomizableLayout?.assignedUsers?.map(Number).length;
                this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
            }
        },

        getLayoutListDetails(data) {
            if (data === 'default') {
                this.layoutDetailsName = 'default';
            } else {
                this.tabIndex = 0;
                this.headerIndex = 0;
                this.layoutDetailsName = 'layout';
                this.layoutName = data;
                this.saveEvent = '';
                this.layoutSettings = 'Layout settings';
                this.showSettingsPage = true;
            }
            this.emitGetAll = true;
            this.getContactLayoutList();
        },

        renderDefault() {
            this.layoutDetailsName = 'default';
        },

        tabSelectedDetails(tabIndex, data) {
            tabIndex = Number(tabIndex) ? Number(tabIndex) : 0;

            this.selectedTab = (data.layoutComponents !== undefined && data.layoutComponents[tabIndex] && data.layoutComponents[tabIndex].name !== undefined) ? data.layoutComponents[tabIndex].name : '';

            this.setTabSelected(this.selectedTab);
        },

        async saveContactLayoutDetails() {
            try {
                const successMessage = 'contact layout created successfully';

                await axios.post('/app/contactLayout/layout/save', this.contactCustomizableLayout);

                this.$toast({ message: successMessage });

                if (this.saveEvent === 'TAB' || this.saveEvent === 'FIELD' || this.saveEvent === 'HEADER') {
                    this.getContactLayoutList();
                }
            } catch (error) {
                this.$error({ message: 'error occurred while adding contact layout details' });
            } finally {
                if (this.saveEvent === 'TAB') {
                    this.modalClose();
                }
            }
        },

        getContactLayoutDetails() {
            if (this.saveEvent === 'TAB') {
                this.contactLayouts.forEach((layout) => {
                    if (this.contactCustomizableLayout.id === layout.id) {
                        this.contactCustomizableLayout = layout;
                        this.layoutData.contactCustomizableLayout = layout;

                        if (layout.layoutComponents && layout.layoutComponents !== undefined) {
                            layout.layoutComponents.forEach((contactLayoutComponentsData) => {
                                if (contactLayoutComponentsData.name === this.tabName) {
                                    this.tabIndex = Number(contactLayoutComponentsData.order);
                                    this.getTabsDropDown();
                                    this.tabSelectedDetails(this.tabIndex, this.contactCustomizableLayout);
                                    this.layoutData.tabIndex = this.tabIndex;
                                    this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
                                }
                            });
                        } else {
                            this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
                        }
                    }
                });
            } else if (this.saveEvent === 'HEADER') {
                this.contactLayouts.forEach((layout) => {
                    if (this.contactCustomizableLayout.id === layout.id) {
                        this.contactCustomizableLayout = layout;
                        this.tabSelectedDetails(this.tabIndex, this.contactCustomizableLayout);
                        this.layoutData.contactCustomizableLayout = this.contactCustomizableLayout;
                        this.layoutData.tabIndex = this.tabIndex;
                        this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
                    }
                });
            } else if (this.saveEvent === 'FIELD') {
                this.contactLayouts.forEach((layout) => {
                    if (this.contactCustomizableLayout.id === layout.id) {
                        layout.layoutComponents.forEach((contactLayoutComponents) => {
                            if (contactLayoutComponents.name === this.selectedTab) {
                                this.contactCustomizableLayout = layout;
                                this.tabIndex = Number(contactLayoutComponents.order);
                                this.layoutData.contactCustomizableLayout = this.contactCustomizableLayout;
                                this.layoutData.tabIndex = this.tabIndex;
                                this.$root.$emit('LAYOUT_DISPLAY_DETAILS_CUSTOM_FIELDS', this.layoutData);
                            }
                        });
                    }
                });
            }
        },
        async getContactLayoutList() {
            try {
                const response = await axios.get(`/app/contactLayout?userId=${this.userId}`);

                this.contactLayouts = response.data;
                const everthinglayoutObj = this.contactLayouts[0];

                this.everyThingLayout = everthinglayoutObj;

                if (this.defaultLayoutId > 0) {
                    this.contactLayouts.forEach((layout) => {
                        if (this.defaultLayoutId === layout.id) {
                            this.contactCustomizableLayout = layout;
                        }
                    });
                    this.layoutDetailsName = 'layout';
                    this.layoutName = this.contactCustomizableLayout.name;
                    this.layoutUsersAccessCount = this.contactCustomizableLayout?.assignedUsers?.map(Number).length;
                    this.tabSelectedDetails(this.tabIndex, this.contactCustomizableLayout);
                    this.$root.$emit('UPDATE_CONTACT_LAYOUT_LIST', this.contactLayouts);
                    this.defaultLayoutId = 0;
                } else if (this.emitGetAll) {
                    this.contactLayouts.forEach((layout) => {
                        if (this.layoutName === layout.name) {
                            this.contactCustomizableLayout = layout;
                            this.layoutUsersAccessCount = layout?.assignedUsers?.map(Number).length;
                        }
                    });

                    if (this.contactCustomizableLayout.name === undefined) {
                        this.contactLayouts.forEach((layout) => {
                            if (this.updatedDefaultLayoutId === layout.id) {
                                this.contactCustomizableLayout = layout;
                            }
                        });
                    }

                    this.tabSelectedDetails(this.tabIndex, this.contactCustomizableLayout);
                    this.$root.$emit('UPDATE_CONTACT_LAYOUT_LIST', this.contactLayouts);
                    this.emitGetAll = false;
                }

                if (this.saveEvent !== '') {
                    this.getContactLayoutDetails();
                } else if (this.updatedDefaultLayoutId === 0 && this.contactCustomizableLayout.name === this.everyThingLayout.name) {
                    this.layoutDetailsName = 'everything';
                    this.layoutName = this.everyThingLayout.name;

                    this.$root.$emit('EVERTHING_LAYOUT_DISPLAY_DETAILS', this.everyThingLayout);
                } else {
                    this.getTabsDropDown();
                    this.layoutData.contactCustomizableLayout = this.contactCustomizableLayout;
                    this.layoutData.tabIndex = this.tabIndex;
                    this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
                }

                if (this.emitDefaultLayoutId) {
                    this.sendDefaultLayout.contactList = this.contactLayouts;
                    this.sendDefaultLayout.actionItem = false;
                    this.sendDefaultLayout.layoutId = this.updatedDefaultLayoutId;
                    this.$root.$emit('CUSTOMIZED_CONTACT_RECORD_LAYOUT_DETAILS', this.sendDefaultLayout);
                    this.sendDefaultLayout = {};
                    this.emitDefaultLayoutId = false;
                }
            } catch (error) {
                this.$error({ message: 'error occurred while getting contact Layout List' });
            }
        },

        openToggleTabDeleteConfirmModal() {
            this.deleteTabNameMessage = 'This action only deletes the tab and headers within the tab, the fields within this tab will NOT be deleted?';
            this.isToggleLayoutConfirmModalOpen = true;
        },

        confirmModalCancel() {
            this.headerID = '';
            this.isToggleLayoutConfirmModalOpen = false;
        },

        getTabsDropDown() {
            this.systemTabList = cloneDeep(this.originalSystemTabList);
            this.getSystemTabList();
        },

        setTabSelected(tabName) {
            return this.selectedTab !== '' && this.selectedTab === tabName;
        },

        getSystemTabList() {
            this.contactCustomizableLayout.layoutComponents && this.contactCustomizableLayout.layoutComponents.forEach((tabName) => {
                if (this.systemTabList.indexOf(tabName.name) !== -1) {
                    this.systemTabList.splice(this.systemTabList.indexOf(tabName.name), 1);
                }
            });
        },

        showSystemTabField(field) {
            const sysTabIndex = this.systemTabList.indexOf(field);

            if (sysTabIndex !== -1) {
                this.systemTabList.splice(sysTabIndex, 1);
                this.saveTabDetails(field, 'SYSTEM');
            }
        },

        saveTabDetails(field, contentType) {
            this.layoutTab.id = 0;
            this.layoutTab.name = field;
            this.layoutTab.order = this.contactCustomizableLayout.layoutComponents.length;
            this.layoutTab.components = [];
            this.layoutTab.componentType = 'TAB';
            this.layoutTab.contentType = contentType;
            this.tabName = field;

            this.contactCustomizableLayout.layoutComponents.push(this.layoutTab);
            this.saveEvent = 'TAB';
            this.layoutTab = {};
            this.saveContactLayoutDetails();
        },

        updateTabOrder() {
            this.contactCustomizableLayout.layoutComponents = this.contactCustomizableLayout.layoutComponents.map((item, index) => {
                item.order = index;

                return item;
            });
            this.saveEvent = 'TAB';
            this.saveContactLayoutDetails();
        },

        editTab(contactCustomizableLayout, index) {
            this.showTabAction = false;
            this.enableTabUpdateButtons = true;
            this.tabTitle = 'Edit tab';
            this.tempTabIndex = index;
            this.tabName = contactCustomizableLayout.layoutComponents[index].name;

            if (this.originalSystemTabList.includes(this.tabName)) {
                this.tabErrorMessage = 'System tabs cannot be renamed';
                this.submitted = true;
                this.enableSaveTabButton = true;
                this.disableSave = true;
            } else {
                this.tabErrorMessage = '';
                this.submitted = false;
                this.enableSaveTabButton = false;
                this.disableSave = false;
            }
            this.isTabModalOpen = true;
        },

        updateTabButton() {
            let isTabNameExists = false;

            this.contactCustomizableLayout.layoutComponents.forEach((contactLayoutComponents) => {
                if (contactLayoutComponents.name === this.tabName) {
                    isTabNameExists = true;
                }
            });

            if (this.tabName.length === 0) {
                this.enableSaveTabButton = false;
                this.submitted = true;

                return;
            }

            if (this.contactCustomizableLayout.layoutComponents[this.tempTabIndex].name === this.tabName) {
                this.modalClose();
            } else if (isTabNameExists) {
                this.enableSaveTabButton = true;
                this.tabErrorMessage = 'This tab name already exists. Please select a unique tab name.';
            } else {
                this.contactCustomizableLayout.layoutComponents[this.tempTabIndex].name = this.tabName;
                this.saveEvent = 'TAB';
                this.saveContactLayoutDetails();
            }
        },

        async confirmModalTabDelete() {
            try {
                await axios.delete(`/app/contactLayout/field/${this.contactCustomizableLayout.layoutComponents[this.tempTabIndex].id}`);
                this.$toast({ message: 'tab deleted successfully' });
                this.selectedTab = '';
                this.tabIndex = 0;
                this.tempTabIndex = 0;
                this.headerIndex = 0;
                this.saveEvent = '';
                this.emitGetAll = true;
                this.getContactLayoutList();
                this.isToggleLayoutConfirmModalOpen = false;
            } catch (error) {
                this.$error({ message: 'error occurred while deleting tab' });
            } finally {
                this.modalClose();
            }
        },

        sendTabEvent(tabName, index) {
            this.tabIndex = index;
            this.enableAddHeader = true;
            this.selectedTab = tabName;

            this.layoutData.contactCustomizableLayout = this.contactCustomizableLayout;
            this.layoutData.tabIndex = this.tabIndex;
            this.$root.$emit('LAYOUT_DISPLAY_DETAILS', this.layoutData);
        },

        addATabModal() {
            this.showTabAction = true;
            this.tabTitle = 'Create a new tab';
            this.tabName = '';
            this.tabErrorMessage = '';
            this.submitted = false;
            this.enableSaveTabButton = false;
            this.isTabModalOpen = true;
        },

        addATab() {
            let isTabNameExists = false;

            this.contactCustomizableLayout.layoutComponents.forEach((contactLayoutComponents) => {
                if (contactLayoutComponents.name === this.tabName) {
                    isTabNameExists = true;
                }
            });

            if (this.tabName.length === 0) {
                this.enableSaveTabButton = false;
                this.submitted = true;

                return;
            }

            if (isTabNameExists) {
                this.enableSaveTabButton = true;
                this.tabErrorMessage = 'This tab name already exists. Please select a unique tab name.';
            } else {
                this.layoutTab.id = 0;
                this.layoutTab.name = this.tabName;
                this.layoutTab.componentType = 'TAB';
                this.layoutTab.contentType = 'CUSTOM';
                this.layoutTab.order = this.contactCustomizableLayout.layoutComponents.length;
                this.contactCustomizableLayout.layoutComponents.push(this.layoutTab);
                this.saveEvent = 'TAB';
                this.layoutTab = {};
                this.emitGetAll = true;
                this.saveContactLayoutDetails();
            }
        },

        modalClose() {
            this.tempTabIndex = 0;
            this.showTabAction = true;
            this.enableTabUpdateButtons = false;
            this.tabTitle = '';
            this.isTabModalOpen = false;
        },

    },
};
</script>

<style lang="scss" scoped>
#closeIcon {
    margin-right: $spacing-100;
}
.contact-layout-header {
    border-collapse: collapse;
    width: 100%;
}

.header-line {
    width: 100%;
    padding: 1rem 1rem 0;
}

.grid-container {
    display: inline-flex;
    align-items: center;
    margin-top: $spacing-200;
}

.layout {
    width: 100%;
    display: flex;
    margin: -$spacing-300;
}

.grid-item {
    margin: auto;
}

.layout-details {
    flex-direction: column;
    height: 100vh;
    overflow-y: auto;
    width: 50rem;
    padding-left: px-to-rem(60px);
    padding-top: $spacing-100;
}

.profile-label {
    margin-left: 0;
}

.layout-list-name {
    position: relative;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    padding: 0;
    height: 100%;
}

.status-placeholder.capsule-buttons {
    cursor: grabbing;
    max-width: px-to-rem(200);
    height: px-to-rem(35);
    background: $color-gray-200;
    * {
        visibility: hidden;
    }
}

.card-dragging.capsule-buttons {
    cursor: grabbing;
    transform: rotate(10deg);
}

@media screen and ($small) {

    .layout {
        display: flex;
    }
}

.vert {
    display: inline-block;
    border: 0.5px solid $color-gray-light;
}

.horiz {
    border: 0.5px solid $color-gray-light;
    width: 58rem;
    margin-top: $spacing-200;
}

@media only screen and ($small) {
    .horiz {
        margin-top: $spacing-500;
    }
    .vert {
        border: 0.5px solid $color-gray-light;
    }
}

.layout-tab-content {
    padding: $spacing-200;
}

.description {
    padding: $spacing-200 0;
}

.capsule-buttons {
    margin: $spacing-075 $spacing-025;
    height: 1.75rem;
    display: inline-flex;
    align-items: center;
    font-size: small;
    color: $color-text;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    background-color: $color-gray-20;
    border: none;
    border-radius: 1.75rem;
    cursor: pointer;

    &:hover,
    &:active {
        color: $color-text;
        background-color: $color-gray-light;
        box-shadow: $drop-shadow-z2;
    }

    &:focus {
        outline: 0;
    }
}

.dropdown-menu-item {
    white-space: pre-wrap;
}

.tab-selected {
    background-color: $color-white;
    box-shadow: $drop-shadow-z2;
}

.record {
    display: flex;
    overflow-y: hidden;
}

.slides {
    display: flex;
    flex-flow: row wrap;
    @include padding-start($spacing-050);

    > div {
        @include margin-end($spacing-100);
    }
}

@media screen and ($small) {
    .record {
        margin: 0 ($spacing-300 * -1);
    }

    .slides {
        flex-flow: row nowrap;
        overflow-x: auto;
        padding: 0 $spacing-300;
    }

    .slides::-webkit-scrollbar {
        display: none;
    }
}

@media screen and ($medium) {
    .slides {
        display: flex;
        overflow: auto;
    }

    ::-webkit-scrollbar {
        width: 0;
        background: transparent;
    }
}

.drag-icon {
    display: inline-flex;
    --icon-color: $color-gray;
    cursor: pointer;
    --icon-size: 1rem;
    margin: 0 $spacing-100 0 $spacing-050;
}

.drag-target-draggable {
    margin-right: $spacing-100;
}

.card-image {
    height: 20rem;
    object-fit: cover;
    box-shadow: 0 $spacing-050 $spacing-100 0 rgba(0, 0, 0, 0.2);
    margin: $spacing-250;
    background-color: $color-gray-10;
    border-radius: 1rem;
}

.card-header {
    justify-content: space-around;
    text-align: center;
    font-size: $font-size-md;
    text-justify: initial;
    margin-right: auto;
    margin-left: auto;
    font-weight: 300;
    padding-top: 8rem;
    padding-bottom: 3rem;
}


.button-space {
    display: flex;
    justify-content: space-between;
}

.enableTabSaveText {
    color: $color-red;
}

.add-tab-label {
    margin-left: $spacing-100;
}

.add-section-tab-label {
    color: $color-gray;
    margin-left: $spacing-100;
}

.add-tab-dropdown-menu-list {
    padding: 0.01rem 0;
}

.add-a-tab-label {
    margin-left: $spacing-100;
    margin-top: 0.4rem;
    float: right;
}

.minus {
    color: #{$color-red};
    --icon-color: #{$color-red};

    &.selected {
        --icon-color: #{$color-red};
    }
}

.ds-card-header {
    padding: 0.5rem;
    display: grid;
    margin-top: 0.2631rem;
    grid-gap: 0.5rem;
}

.ds-card-body {
    padding: 0.25rem;
}

.accordion-body {
    border-top: solid px-to-rem(1px) $color-gray-200;
}

.ds-card {
    margin-bottom: $spacing-200;
    max-width: 100%;
    cursor: pointer;
}

.tab-names {
    font-size: $font-size-lg;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.2;
    letter-spacing: normal;
}

.contacts-list-page.layout {
    max-width: 22.5rem;
    height: 100vh;
}

@media (min-width: 750px) {
    .contacts-list-page.layout .side-panel {
        border-right: 1px solid #e7e7e7;
        max-width: 22.5rem;
    }
}

.contacts-list-page.layout .side-panel {
    width: 100%;
}

.contacts-list-page.layout > section[data-v-30c5ca62] {
    overflow-y: auto;
}

.content-area {
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -webkit-overflow-scrolling: auto !important;
}

.layoutSettingsTab {
    color: $color-black;
    background-color: $color-white;
    border-radius: 2px;
    &:hover,
    &:active {
        color: $color-text;
    }
}

.placeholder-line {
    border-bottom: 2px solid $color-green;
}

.basic-dropdown-list{
    --dropdown-height: #{px-to-rem(288px)};
    --dropdown-minwidth: #{px-to-rem(200px)};
    --dropdown-maxwidth: #{px-to-rem(275px)};
}
</style>
